export const APPROVAL_PAGE_SIZE = 20;

const parseNumeric = (value) => {
  if (value == null || value === "") return null;
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
};

/**
 * Infers the server page size from a DRF-style paginated response.
 * The API does not accept page_size; the backend decides how many rows per page.
 */
export const resolveServerPageSize = (data, items, knownPageSize = APPROVAL_PAGE_SIZE) => {
  const hasNext = Boolean(data?.next);
  const hasPrevious = Boolean(data?.previous);

  if (hasNext && items.length > 0) {
    return items.length;
  }
  if (hasPrevious && knownPageSize > 0) {
    return knownPageSize;
  }
  if (items.length > 0) {
    return items.length;
  }
  return knownPageSize;
};

/**
 * Normalizes GET /api/student/approvals/ responses (DRF-wrapped or flat).
 *
 * Expected shape:
 * { count, next, previous, results: { object, total, pending, approved, ... } }
 */
export const parseApprovalListResponse = (
  res,
  { knownPageSize = APPROVAL_PAGE_SIZE, currentPage = 1 } = {}
) => {
  const data = res?.data || {};
  const payload =
    data.results && typeof data.results === "object" && !Array.isArray(data.results)
      ? data.results
      : data;
  const items = Array.isArray(payload.object)
    ? payload.object
    : Array.isArray(data.object)
      ? data.object
      : [];

  const rowCount =
    parseNumeric(data.count) ??
    parseNumeric(payload.total) ??
    parseNumeric(payload.total_count) ??
    parseNumeric(data.total_count) ??
    items.length;

  const serverPageSize = resolveServerPageSize(data, items, knownPageSize);

  return {
    data,
    payload,
    items,
    rowCount,
    serverPageSize,
    hasNext: Boolean(data.next),
    hasPrevious: Boolean(data.previous),
    currentPage: Math.max(1, Number(currentPage) || 1),
  };
};
